import React from "react"
import howToApply from "assets/images/services/env-audit/how-to-apply-env-audit.jpeg"

const EnvironmentalAuditDescription = props => {
  return (
    <div className="field-item even" property="content:encoded">
      {/* <br></br>
      <h4>How to Apply</h4>
      <br></br>
      <p>
        • <strong>Download and Review the Template:</strong> Download the
        template for application and review it carefully, to understand the
        requirement
        <br></br>• <strong>Fill Out the Application Template:</strong> Complete
        the application form accurately and thoroughly.
        <br></br>• <strong>Prepare Documents:</strong> Gather all required
        documents (e.g., track record, legal status
        document, ect).
        <br></br>• <strong>Submit the Application:</strong> Follow the
        submission instructions, and attach all required documents and submit
      </p> */}

      <img src={howToApply} alt="how to apply" />
    </div>
  )
}

export default EnvironmentalAuditDescription
